// aws api profiles
import api from '../../aws/api/profiles/json.profile.api.aws';

const loadCreditSafeFinancialsApi = (supplierId) =>
  api().get(
    `/data/cache/creditsafe/output/latest/financials/${supplierId}.json`
  );

export default loadCreditSafeFinancialsApi;
